import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';

registerLocaleData(localeIt, 'it');

// modules (angular)
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// modules (third-party)
import { CarouselModule } from 'ngx-owl-carousel-o';
import { ToastrModule } from 'ngx-toastr';

// modules
import { AppRoutingModule } from './app-routing.module';
import { BlocksModule } from './modules/blocks/blocks.module';
import { FooterModule } from './modules/footer/footer.module';
import { HeaderModule } from './modules/header/header.module';
import { MobileModule } from './modules/mobile/mobile.module';
import { SharedModule } from './shared/shared.module';

// components
import { AppComponent } from './app.component';
import { RootComponent } from './components/root/root.component';

// pages
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { PageOffcanvasCartComponent } from './pages/page-offcanvas-cart/page-offcanvas-cart.component';
import { HttpConfigInterceptor } from './interceptor/httpconfig.interceptor';
import { HttpClient, HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';


import { StoreService } from './shared/services/store.service';
import { PageChiSiamoComponent } from './pages/page-chi-siamo/page-chi-siamo.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { PagePolicyDittaComponent } from './pages/page-policy-ditta/page-policy-ditta.component';
import { SpedizioniDisponibiliComponent } from './components/spedizioni-disponibili/spedizioni-disponibili.component';
import { ShimmerModule } from '@sreyaj/ng-shimmer';
import { SiteInfoComponent } from './components/site-info/site-info.component';
import { EditPageComponent } from './components/edit-page/edit-page.component';
import { AdminPageComponent } from './components/admin-page/admin-page.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslocoRootModule } from './modules/translate/transloco-root.module';
import { ResturantMenuComponent } from './pages-restaurant/restaurant-home/resturant-menu.component';
import { RestaurantSharedModule } from './pages-restaurant/shared/restaurant-shared-module';
import { ListMenuComponent } from './pages-restaurant/restaurant-list/list-menu.component';
import { ProductMenuPageComponent } from './pages-restaurant/product-page/product-menu-page.component';
import { CategoryListContainerComponent } from './pages-restaurant/category-list-container/category-list-container.component';
import { SearchListContainerComponent } from './pages-restaurant/search-list-container/search-list-container.component';
import { RestaurantcartComponent } from './pages-restaurant/restaurantcart/restaurantcart.component';
import { RestaurantcheckoutComponent } from './pages-restaurant/restaurantcheckout/restaurantcheckout.component';
import { RestaurantordersuccessComponent } from './pages-restaurant/restaurantordersuccess/restaurantordersuccess.component';
import { RestaurantboxComponent } from './pages-restaurant/restaurantbox/restaurantbox.component';
import { RestaurantHeaderComponent } from './pages-restaurant/shared/restaurant-header/restaurant-header.component';
import { RestaurantBannerComponent } from './pages-restaurant/shared/restaurant-banner/restaurant-banner.component';
import { LoadingShimmerComponent } from './loading-shimmer/loading-shimmer.component';



export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export function appInit(store: StoreService) {
    return () => store.load();
}


@NgModule({
    declarations: [
        // components
        AppComponent,
        RootComponent,
     
        // pages
        PageNotFoundComponent,
        PageOffcanvasCartComponent,
        PageChiSiamoComponent,
        PagePolicyDittaComponent,
        SpedizioniDisponibiliComponent,
        SiteInfoComponent,
        EditPageComponent,
        AdminPageComponent,
        ResturantMenuComponent, 
        ListMenuComponent,
        ProductMenuPageComponent,
        CategoryListContainerComponent,
        SearchListContainerComponent,
        RestaurantcartComponent,
        RestaurantcheckoutComponent,
        RestaurantordersuccessComponent,
        RestaurantboxComponent,
        RestaurantBannerComponent,
        LoadingShimmerComponent,
    ],
    imports: [
        // modules (angular)
        BrowserModule.withServerTransition({ appId: 'serverApp' }),
        BrowserAnimationsModule,
        ReactiveFormsModule,
        FormsModule,
        // modules (third-party)
        CarouselModule,
        TranslocoRootModule,
        ToastrModule.forRoot({
            maxOpened: 1,
            autoDismiss: true
        }),
        // modules
        AppRoutingModule,
        BlocksModule,
        FooterModule,
        HeaderModule,
        MobileModule,
        SharedModule,
        NgxSpinnerModule,
        ShimmerModule,
        RestaurantSharedModule,
        FooterModule,
        HttpClientModule,
    
        
        TranslateModule.forRoot({
      defaultLanguage: 'it',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),

    ],
    exports:
        [ResturantMenuComponent,
        RestaurantHeaderComponent
        ],
    providers: [
        { provide: LOCALE_ID, useValue: 'it' },
        { provide: HTTP_INTERCEPTORS, useClass: HttpConfigInterceptor, multi: true },
        { provide: APP_INITIALIZER, useFactory: appInit, deps: [StoreService], multi: true }
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
    constructor() {
    }
}
